import script from "./InstagramLiveReportLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./InstagramLiveReportLayout.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__